<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '>' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>授权服务订单列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="swb-back-row">
            <div class="order-search-container">
                <a class="all-order mb10">全部订单</a>
                <swb-servc-order-search :no="no" @showServcOrderSearch="showSearch"></swb-servc-order-search>
            </div>
            <div class="orders-list-container">
                <table class="orders-list-panel1">
                    <colgroup>
                        <col width="450px">
                        <col width="250px">
                        <col width="150px">
                        <col width="150px">
                        <col width="100px">
                        <col width="100px">
                    </colgroup>
                    <thead class="orders-header">
                    <tr class="">
                        <th>服务信息</th>
                        <th style="text-align: left">买家信息</th>
                        <th>金额</th>
                        <th>交易状态</th>
                        <th>交付状态</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody class="orders-body" v-if="servOrderList != null && servOrderList.length > 0" v-for="(servcOrder, index) in servOrderList">
                    <tr class="blank-row">
                        <td colspan="6"></td>
                    </tr>
                    <tr class="abstract-row">
                        <td colspan="6">
                            <div class="abstract-content">
                                <span class="mr30">创建时间：{{servcOrder.createTime}}</span>
                                <span class="mr30">商家名称：{{servcOrder.buyerComName}}</span>
                                <span class="mr30">订单号:{{servcOrder.no}}</span>
                                <span class="" v-if="servcOrder.beyondWrnt">交易单号：<a class="swb-btn-link" @click.stop="toTradeVoucherList(servcOrder.tradeNo,servcOrder.contractId)">{{servcOrder.tradeNo}}</a></span>
                                <span class="mr5 font-gray3"></span>
                                <span class="mr5 font-gray3"></span>
                            </div>
                            <div v-if="servcOrder.proxied" class="table-tips order"></div>
                        </td>
                    </tr>
                    <tr class="info-row">
                        <td>
                            <div class="goods-info-block" style="overflow: hidden" v-if="servcOrder.itemList != null && servcOrder.itemList.length > 0" v-for="(servcOrderItem, index) in servcOrder.itemList">
                                <div class="goods-item clearfix">
                                    <div class="good-img">
                                        <img v-if="servcOrderItem.servcFileBrowseUrl != null" class="wh100" :src="servcOrderItem.servcFileBrowseUrl"/>
                                    </div>
                                    <div class="good-msg">
                                        <p class="ellipsis-2 font12 align-left">
                                            <span>{{servcOrderItem.title}}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div>
                                <div class="font14 align-left">{{servcOrder.buyerShopContactName}}</div>
                                <div class="font14 align-left">买家名称:{{servcOrder.buyerName}}</div>
                                <div class="font14 align-left">联系方式：{{servcOrder.buyerShopContactTel}}</div>
                                <div class="font14 align-left">机构名称:{{servcOrder.buyerShopName}}</div>
                                <div class="font14 align-left">机构地址:{{servcOrder.buyerShopAddr}}</div>
                            </div>
                        </td>
                        <td>
                            <div class="font-gray1" v-if="!userIsShopFlag">
                                <span>总额 ¥<b class="pri">{{parseFloat(servcOrder.amount).toFixed(2)}}</b></span>
                            </div>
                        </td>
                        <td>
                            <div v-if="servcOrder.servicerShopFlag == true">{{servcOrder.servicerShopName}}</div>
                            <div class="font14 font-gray2" v-if="servcOrder.workAssignStateX != null"><span>派工状态:{{workAssignStateX[servcOrder.workAssignStateX]}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="font14 font-gray2" v-if="servcOrder.state != null">{{servcOrder.state}}</div>
                            <div class="swb-btn swb-btn-link" v-if="checkActionPerm('view_detail')" @click="searchOrder(servcOrder.id)">
                                <i class="icon iconfont"></i><span>订单详情</span>
                            </div>
                        </td>
                        <td>
                            <!--<div class="swb-btn swb-btn-link" @click="complaintSave(servcOrder.id)">
                                <span>发起投诉</span>
                            </div>-->
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'

    import userApi from '../../api/user'
    import servcOrderApi from '../../api/servcOrder'

    import SwbServcOrderOperate from './ServcOrderOperate';
    Routes.add(SwbServcOrderOperate);

    import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';
    Routes.add(SwbTradeVoucherList);

    import SwbServcOrderSearchLet from './ServcOrderSearchLet'
    Vue.regist(SwbServcOrderSearchLet);

    export default {
        name: 'swb-servc-order-trade-list',
        path: '/servc/order/list/based/on/req',
        pathOld: '/servc/order/reqVoucher/list',
        avlActions: 'view_detail',
        avlScopes: 'servicer',
        desc: '请求服务订单列表',
        authen: false,
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                servOrderList: [],
                servcOrderStateList: [],
                createOrderStart: null,
                createOrderEnd: null,
                no: null,
                isSelf: false,
                userIsShopFlag: null,
                workAssignStateX: [],
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                servcOrderType: "ServcReq"
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            let self = this;
            let no = this.$route.query.no || null;
            if(!Utils.isNoB(no)) {
                this.no = no;
                this.queryModel.filterItems.no = no;
            }
            self.workAssignStateX = getEnumMap("workAssignStateX", "value2text");
            let servcOrderStateList = getEnumList("servcOrderState", true);
            for(let i = 0; i < servcOrderStateList.length; i++) {
                let servcOrderState = servcOrderStateList[i];
                if(servcOrderState.name == "AppointShop") {
                    servcOrderStateList.splice(i, 1);
                }
            }
            self.servcOrderStateList = servcOrderStateList;
            self.getServOrderList();
            self.getCurrentUserInfo();
        },
        methods: {
            showSearch: function (data) {
                this.queryModel = data;
                this.getServOrderList();
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == "info") {
                        self.userIsShopFlag = result.data.scopeEntity.shopFlag;
                    }
                })
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getServOrderList();
            },
            selectionMenu: function (value) {
                let self = this;
                let servcOrderStateList = self.servcOrderStateList;
                for(let i = 0; i < servcOrderStateList.length; i++) {
                    let servcOrderState = servcOrderStateList[i];
                    if(servcOrderState.value == value) {
                        self.servcOrderState = value;
                        self.getServOrderList();
                    }
                }
            },
            getServOrderList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.servcOrderType = this.servcOrderType;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let loading = MsgBox.loading();
                servcOrderApi.getServOrderList(postData, function (result) {
                    if(result.type == "info") {
                        let data = result.data;
                        let servOrderList = data.rows;
                        //
                        self.servOrderList = servOrderList;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        loading.close();
                    } else {
                        loading.close();
                        MsgBox.warning(result.message);
                    }
                });
            },
            searchOrder: function (orderId) {
                this.$router.push({
                    path: SwbServcOrderOperate.path,
                    query: {
                        id: orderId,
                    }
                });
            },
            toTradeVoucherList: function (tradeNo, contractId) {
                let self = this;
                let tradeType = null;
                if(!Utils.isNoB(contractId)) {
                    tradeType = getEnumInfoWith("tradeVoucherType", 'name', 'ContractVoucher').value;
                } else {
                    tradeType = getEnumInfoWith("tradeVoucherType", 'name', 'GeneralVoucher').value;
                }
                self.$router.push({
                    path: SwbTradeVoucherList.path,
                    query: {
                        no: tradeNo,
                        tradeVoucherType: tradeType
                    }
                })
            },
            parseFloat: function (price) {
                if(isNoB(price)) {
                    price = 0.00;
                }
                return Utils.parseFloat(price);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcOrder/ServcOrderTradeList.vue